<template>
  <ContainerComponent>
    <div class="main">
      <div class="content">
        <div class="container">
          <div class="body">
            <div class="image-container">
              <div class="placeholder">
                <i v-show="loadingShowcase" class="icon loading" />
                <div>
                  <div class="slide-nav slide-left">
                    <i
                      class="icon icon-chevron-left text-xl clickable"
                      @click="slideLeft()"
                    />
                  </div>
                  <div class="image-wrapper">
                    <img
                      class="image-placeholder" 
                      :src="require(`@/assets/silicon/${slides[activeSlide]}.jpg`)"
                    />
                  </div>
                  <div class="slide-nav slide-right">
                    <i
                      class="icon icon-chevron-right text-xl clickable"
                      @click="slideRight()"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ref="productFamilyFooter" class="bottom-escape">
          <div class="bottom-inner">
            <router-link class="btn showcase-btn" :to="{ name: 'radio' }">
              Return
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </ContainerComponent>
</template>

<script>
import ContainerComponent from '@/components/ContainerComponent';
import InlineSvg from 'vue-inline-svg';

export default {
  components: {
    ContainerComponent,
    InlineSvg
  },
  props: {
    productsId: { type: String, default: 'productViewer' }
  },
  data() {
    return {
      loadingShowcase: false,
      activeSlide: 0,
      slides: [
        'Slide1',
        'Slide2',
        'Slide3'
      ]
    };
  },
  methods: {
    slideLeft() {
      this.activeSlide = this.activeSlide === 0 ? this.slides.length - 1 : this.activeSlide - 1;
    },
    slideRight() {
      this.activeSlide = this.activeSlide === this.slides.length - 1 ? 0 : this.activeSlide + 1;
    },
    activateSlide(index) {
      this.activeSlide = index;
    },
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.main {
  display: flex;
  flex: 1;
  background-color: @layer1;
  .content {
    margin: @space-base @space-large @space-large @space-large;
    display: flex;
    flex: 1;
    flex-direction: column;
    .header {
      display: flex;
      flex-direction: row;
      margin-top: 42px;
      margin-left: 20px;
    }
  }
}

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  .body {
    display: flex;
    flex: 1;
  }
}

.slide-left {
  position: absolute;
  top: 48%;
  z-index: 10;
}

.slide-right {
  position: absolute;
  top: 48%;
  left: calc(100% - 50px);
  z-index: 10;
}

.slide-nav i {
  font-size: 46px;
}

.slide-nav:hover i {
  font-size: 48px;
}

.placeholder {
  position: relative;
  display: block;
  height: 100%;
}

.image-container {
  width: 100%;
  height: 100%;
}

.image-wrapper {
  text-align: center;
}

.image-placeholder {
  position: absolute;
  height: 100%;
  transform: translate(-50%, 0%);
}

svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  ::v-deep polygon {
    cursor: pointer;
    color: #00000000;
    fill: transparent;
  }
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bottom-escape {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xxl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
  .icon-general {
    width: @font-size-lg;
    height: @font-size-lg;
  }
}
</style>
